(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-journey-legacy"] && !Shopify.designMode) return;
  try {
    (() => {
  const fill = () => {
    const product = new URLSearchParams(window.location.search).get('produkt');
    if (!product) return;
    document.querySelectorAll('[data-journey-message]').forEach(field => {
      if (!field.value) field.value = field.dataset.journeyPrefix + product.slice(0, 300) + '\n\n';
    });
  };
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-journey-filter]')) return;
    event.target.querySelectorAll('select').forEach(select => { select.disabled = !select.value; });
  });
  fill();
  document.addEventListener('shopify:section:load', fill);
})();
  } catch(e) { console.error(e); }
})();

})();
